define("shared/components/shared/wizard", ["exports", "@ember/component", "@ember/object", "@ember/object/computed", "@ember/runloop", "@ember/service", "@ember/utils", "@glimmer/component", "@glimmer/tracking", "@ember/template-factory"], function (_exports, _component, _object, _computed, _runloop, _service, _utils, _component2, _tracking, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/object/computed",0,"@ember/runloop",0,"@ember/service",0,"@ember/utils",0,"@glimmer/component",0,"@glimmer/tracking",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div {{did-insert this.setUpSlides}}>
    <Shared::Modal
      @closable={{@closable}}
      @close={{if @onClose @onClose @onFinish}}
      @focusTrap={{@focusTrap}}
      @inline={{@inline}}
      @primaryClass={{this.primaryClass}}
      as |modal|
    >
      {{yield
        (hash
          slide=(component
            "shared/wizard/slide"
            modal=modal
            finishWizard=(action "finishWizard")
            slideProgressString=this.slideProgressString
            activeSlideId=this.activeSlideId
            isFirstSlide=this.isFirstSlide
            isLastSlide=this.isLastSlide
            registerSlide=(action "registerSlide")
            nextSlide=(action "nextSlide")
            previousSlide=(action "previousSlide")
          )
        )
      }}
    </Shared::Modal>
  </div>
  */
  {
    "id": "5QKXo4j8",
    "block": "[[[11,0],[4,[38,0],[[30,0,[\"setUpSlides\"]]],null],[12],[1,\"\\n  \"],[8,[39,1],null,[[\"@closable\",\"@close\",\"@focusTrap\",\"@inline\",\"@primaryClass\"],[[30,1],[52,[30,2],[30,2],[30,3]],[30,4],[30,5],[30,0,[\"primaryClass\"]]]],[[\"default\"],[[[[1,\"\\n    \"],[18,7,[[28,[37,4],null,[[\"slide\"],[[50,\"shared/wizard/slide\",0,null,[[\"modal\",\"finishWizard\",\"slideProgressString\",\"activeSlideId\",\"isFirstSlide\",\"isLastSlide\",\"registerSlide\",\"nextSlide\",\"previousSlide\"],[[30,6],[28,[37,6],[[30,0],\"finishWizard\"],null],[30,0,[\"slideProgressString\"]],[30,0,[\"activeSlideId\"]],[30,0,[\"isFirstSlide\"]],[30,0,[\"isLastSlide\"]],[28,[37,6],[[30,0],\"registerSlide\"],null],[28,[37,6],[[30,0],\"nextSlide\"],null],[28,[37,6],[[30,0],\"previousSlide\"],null]]]]]]]]],[1,\"\\n  \"]],[6]]]]],[1,\"\\n\"],[13]],[\"@closable\",\"@onClose\",\"@onFinish\",\"@focusTrap\",\"@inline\",\"modal\",\"&default\"],false,[\"did-insert\",\"shared/modal\",\"if\",\"yield\",\"hash\",\"component\",\"action\"]]",
    "moduleName": "shared/components/shared/wizard.hbs",
    "isStrictMode": false
  });
  let WizardComponent = _exports.default = (_dec = (0, _computed.reads)('args.defaultIndex'), _dec2 = (0, _computed.reads)('args.cacheKey'), (_class = class WizardComponent extends _component2.default {
    constructor() {
      super(...arguments);
      /**
       * @property intl
       * @type {IntlHelpersService}
       */
      _initializerDefineProperty(this, "intl", _descriptor, this);
      _initializerDefineProperty(this, "cache", _descriptor2, this);
      /**
       * Index of the active slide in the slides array
       *
       * @property activeSlideIndex
       * @type {Number}
       * @default 0
       */
      _initializerDefineProperty(this, "activeSlideIndex", _descriptor3, this);
      /**
       * A list of slides passed to the Wizard
       *
       * @property slides
       * @type {Array}
       */
      _initializerDefineProperty(this, "slides", _descriptor4, this);
      /**
       * An optional default index
       *
       * @property defaultIndex
       * @type {Number}
       */
      _initializerDefineProperty(this, "defaultIndex", _descriptor5, this);
      /**
       * An optional string value prepended to the cache key
       *
       * @property cacheKey
       * @type {String}
       */
      _initializerDefineProperty(this, "cacheKey", _descriptor6, this);
    }
    get primaryClass() {
      return this.args.primaryClass ?? 'o--modalBg';
    }

    /**
     * Unique element ID of the active slide component
     *
     * @property activeSlideId
     * @type {String}
     */
    get activeSlideId() {
      if (!this.slides.length) {
        return null;
      }
      return this.slides[this.activeSlideIndex].uniqueId;
    }

    /**
     * Returns true if the current slide is the first slide of the wizard
     * (when the index is equal to 0) or that all preceding slides before
     * first active slide has been skipped
     *
     * @property isFirstSlide
     * @type {Boolean}
     */
    get isFirstSlide() {
      const hasNoPrecedingSlides = this.precedingSlides.every(slide => slide.args.skip);
      return this.activeSlideIndex === 0 || hasNoPrecedingSlides;
    }

    /**
     * Returns true if the current slide is the last slide of the wizard
     * (when the index is equal to the length of the wizard minus 1)
     *
     * @property isLastSlide
     * @type {Boolean}
     */
    get isLastSlide() {
      return this.activeSlideIndex === this.slides.length - 1;
    }

    /**
     * Returns an array of slides that precede the current active slide
     *
     * @property precedingSlides
     * @type {Array}
     */
    get precedingSlides() {
      return this.slides.slice(0, this.activeSlideIndex);
    }

    /**
     * Defines whether or not the key is removed
     * from the cache when wizard is completed
     *
     * @property removeFromCacheOnFinish
     * @type {Boolean}
     * @default true
     */
    get removeFromCacheOnFinish() {
      return this.args.removeFromCacheOnFinish ?? true;
    }

    /**
     * Displays the current slide number of the wizard slides
     *
     * @property slideProgressString
     * @type {String}
     */
    get slideProgressString() {
      const skipCount = this.precedingSlides.filter(slide => slide.args.skip).length; // Need to count # of slides before current slide that have been skipped
      const unskippedSlides = this.slides.filter(slide => !slide.args.skip);
      return this.intl.t('wizards.shared.slide_progress', {
        idx: this.activeSlideIndex + 1 - skipCount,
        length: unskippedSlides.length
      });
    }

    /**
     * Sets activeSlideIndex to updated index
     *
     * @method goToSlide
     * @param {Integer} idx
     *
     * @return {Integer} sets activeSlideIndex to updated index
     */
    goToSlide(index) {
      if ((0, _utils.isBlank)(index)) {
        return;
      }
      if (this.cacheKey) {
        this.cache.add(this.cacheKey, index, {
          persist: false,
          expiry: this.cache.maxExpiryDate()
        });
      }
      this.activeSlideIndex = index;
    }
    finishWizard() {
      if (this.args.onFinish) {
        this.args.onFinish();
      }
      if (this.cacheKey && this.args.removeFromCacheOnFinish) {
        this.cache.remove(this.cacheKey);
      }
    }
    nextSlide() {
      return this._navigate('forward');
    }
    previousSlide() {
      return this._navigate('backward');
    }
    registerSlide(slide) {
      (0, _runloop.next)(() => this.addSlide(slide));
    }
    addSlide(newSlide) {
      // Check if a slide with the same id already exists in the slides array
      const slideExists = this.slides.some(slide => slide.uniqueId === newSlide.uniqueId);

      // Only insert the slide if it does not exist in cases of re-rendering
      if (!slideExists) {
        this.slides = [...this.slides, newSlide];
      }
    }

    /**
     * Shows corresponding slide of the validated index
     * If unvalidated, goes to the first slide as the default
     *
     * @method setUpSlides
     */
    setUpSlides() {
      const index = this._getDefaultIndex();
      if (index) {
        (0, _runloop.next)(() => this._validateIndex(index) ? this.goToSlide(index) : this.goToSlide(0));
      } else {
        this._validateIndex(this.activeSlideIndex) ? this.goToSlide(this.activeSlideIndex) : this.goToSlide(0);
      }
    }

    /**
     * Checks if an default index or cache index value exists
     * and returns that index
     *
     * @method _getDefaultIndex
     *
     * @return {Number} an index
     */
    _getDefaultIndex() {
      if ((0, _utils.isPresent)(this.defaultIndex)) {
        return this.defaultIndex;
      } else if (this.cacheKey) {
        const cacheIndex = this.cache.retrieve(this.cacheKey);
        if ((0, _utils.isPresent)(cacheIndex)) {
          return cacheIndex;
        }
      }
    }

    /**
     * Increments the activeSlideIndex if parameter passed in is true,
     * decrements if false
     *
     * @method _navigate
     * @param {Boolean} next
     *
     * @return {goToSlide} calls goToSlide method with index passed in
     */
    _navigate() {
      let direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'forward';
      if (direction !== 'forward' && direction !== 'backward') {
        throw new Error(`Wizard component _navigate function must receive either 'forward' or 'backward' as a parameter. Received ${direction}`);
      }
      const incrementor = direction === 'forward' ? 1 : -1;
      let index = this.activeSlideIndex + incrementor;
      while (this.slides[index].args.skip) {
        index += incrementor;
      }
      return this.goToSlide(index);
    }

    /**
     * Validates whether the index refers to a slide that exists
     *
     * @method _validateIndex
     * @param {Integer} index
     *
     * @return {Boolean}
     */
    _validateIndex(index) {
      return index >= 0 && index < this.slides.length;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "cache", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "activeSlideIndex", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return 0;
    }
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "slides", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return [];
    }
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "defaultIndex", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "cacheKey", [_dec2], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "finishWizard", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "finishWizard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "nextSlide", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "nextSlide"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "previousSlide", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "previousSlide"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "registerSlide", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "registerSlide"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setUpSlides", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setUpSlides"), _class.prototype)), _class));
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, WizardComponent);
});